interface RenderMediaContentProps {
    src: string;
    width?: string;
    height?: string;
}

export const RenderMediaContent: React.FC<RenderMediaContentProps> = ({ src, width, height }) => {
    const customStyles = {
        width: width ? `${width}` : 'auto',
        height: height ? `${height}` : 'auto',
    };

    // Helper to check if src is a YouTube link
    const isYouTubeLink = (url: string) => {
        return /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+/.test(url);
    };

    // Helper to extract YouTube video ID
    const getYouTubeId = (url: string) => {
        const regExp = /^.*((youtu.be\/)|(v\/)|(u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[7].length === 11) ? match[7] : null;
    };

    const renderMedia = () => {
        if (isYouTubeLink(src)) {
            const videoId = getYouTubeId(src);
            if (videoId) {
                // Responsive YouTube embed using aspect-ratio container
                return (
                    <div className="w-full" style={{ aspectRatio: '16/9', minHeight: height || '400px' }}>
                        <iframe
                            src={`https://www.youtube.com/embed/${videoId}`}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            className="w-full h-full"
                            style={{ display: 'block', width: '100%', height: '100%' }}
                        />
                    </div>
                );
            }
        }
        if (src.endsWith('.m4v') || src.endsWith('.mp4')) {
            return (
                <video style={customStyles} className="max-h-[40em] w-full" controls>
                    <source src={src} type="video/mp4" />
                </video>
            );
        }
        return <img src={src} alt="Media Content" style={customStyles} className="w-full" />;
    };

    return (
        <div className="flex flex-col lg:flex-row my-4 gap-4">
            {/* Mobile Asset */}
            <div className="block lg:hidden">
                {renderMedia()}
            </div>

            {/* Desktop Asset */}
            <div className="hidden lg:block">
                {renderMedia()}
            </div>
        </div>
    );
};
